
  <div class="swiper-container swiper-container-horizontal" [style.maxHeight]="'50px'" *ngIf="pager">
    <div class="swiper-pagination swiper-pagination-clickable swiper-pagination-bullets" >
      <button class="swiper-pagination-bullet" [ngClass]="{ 'swiper-pagination-bullet-active': j === indexDisplayed, 'activated': j === indexDisplayed }" *ngFor="let b of items; let j = index"></button>
    </div>
  </div>
  <ion-slides
    (ionSlideAutoplay)="onSlideAutoplay($event)"
    (ionSlideAutoplayStart)="onSlideAutoplayStart($event)"
    (ionSlideAutoplayStop)="onSlideAutoplayStop($event)"
    (ionSlideDidChange)="onSlideDidChange($event)"
    (ionSlideDoubleTap)="onSlideDoubleTap($event)"
    (ionSlideDrag)="onSlideDrag($event)"
    (ionSlideNextEnd)="onSlideNextEnd($event)"
    (ionSlideNextStart)="onSlideNextStart($event)"
    (ionSlidePrevEnd)="onSlidePrevEnd($event)"
    (ionSlidePrevStart)="onSlidePrevStart($event)"
    (ionSlideReachEnd)="onSlideReachEnd($event)"
    (ionSlideReachStart)="onSlidePrevStart($event)"
    (ionSlideTap)="onSlideTap($event)"
    (ionSlideWillChange)="onSlideWillChange($event)">

    <ion-slide *ngFor="let item of renderItems; let i = index">
      <ng-container *ngTemplateOutlet="content, context: { $implicit: {item: item, index: getRealIndex(i)} }">
      </ng-container>
    </ion-slide>

  </ion-slides>
